import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as approvalApi from '../../lib/api/approval';

const [LIST_APPROVALS, LIST_APPROVALS_SUCCESS, LIST_APPROVALS_FAILURE] =
  createRequestActionTypes('approval/LIST_APPROVALS');
export const listApprovals = createAction(
  LIST_APPROVALS,
  (type, searchData) => ({ type, searchData }),
);
const listApprovalsSaga = createRequestSaga(
  LIST_APPROVALS,
  approvalApi.getApprovalHistoryByType,
);

const UNLOAD_APPROVALS = 'approval/UNLOAD_APPROVALS';
export const unloadApprovals = createAction(UNLOAD_APPROVALS);

export function* approvalsSaga() {
  yield takeLatest(LIST_APPROVALS, listApprovalsSaga);
}

const initialState = {
  approvals: null,
  error: null,
};

const approvals = handleActions(
  {
    [LIST_APPROVALS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      approvals: data.info.map((approval) => ({
        id: approval.DOCU_UUID,
        apprUuid: approval.APPR_UUID,
        docuUuid: approval.DOCU_UUID,
        docuTyp: approval.DOCY_TYP,
        partnerInc: approval.PARTNER_INC,
        cstNm: approval.CST_NM,
        docuNo: approval.DOCU_NO,
        docuCd: approval.DOCU_CD,
        docuStep: approval.DOCU_STEP,
        docuUsr: approval.DOCU_USR,
        USR_DATA: approval.USR_DATA,
        // docuUsrNm: approval.DOCU_USR_NM,
        // docuUsrProfile: approval.DOCU_USR_PROFILE,
        // docuUsrDptNm: approval.DOCU_DT,
        // docuUsrGradeNm: approval.GRADE_NM,
        docuYn: approval.DOCU_YN,
        docuTxt: approval.DOCU_TXT,
        docuCnt: approval.DOCU_CNT, //총 결재단계
        docuNow: approval.DOCU_NOW, //현재 단계
        docuNowUsr: approval.DOCU_NOW_USR, //현재 단계 결재자
        docuStatus: approval.DOCU_STATUS,
        crtUsr: approval.CRT_USR,
        crtNm: approval.CRT_NM,
        crtDt: approval.CRT_DT,
      })),
      error: null,
    }),
    [LIST_APPROVALS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_APPROVALS]: () => initialState,
  },
  initialState,
);

export default approvals;
